import React, { useCallback, useContext, useEffect, useState } from "react";
import CommonLayout from "../../Components/CommonLayout/CommonLayout";
import OrderComp from "../Dashboard/Order/OrderComp";
import PromocodeComp from "./PromocodeComp";
import { DiscountApi } from "../../App/api/setting";
import promoimg from "../../Assets/images/offer_promo.png";
import { ErrorMessage, Form, Formik } from "formik";
import moment from "moment";
import LoaderContext from "../../Components/loader";
import { toast } from "react-toastify";
import SidebarField from "../../Components/SidebarField";
import Tooltip from "../../Components/Tooltip/Tooltip";
import DeleteFieldModal from "../../Components/DeleteFieldModal";
import { useSelector } from "react-redux";
import { t } from "i18next";
import {
  CategoryApi,
  productApi,
  SubCategoryApi,
} from "../../App/api/menu.apis";
import { MdEdit } from "react-icons/md";
import ImagePreview from "../../Components/ImagePreview";
import { Calendar } from "primereact/calendar";
import CalendarComp from "../../Components/CalendarComp/CalendarComp";
import TextInput from "../../Components/TextInput";
import MultiSelectDropDown from "../../Components/Dropdown/MultiSelectDropDown";
import Button from "../../Components/Button";
import { UsersApi } from "../../App/api/users.api";

const Promocode = ({ meta }) => {
  const { currentUser } = useSelector((state) => state.store);
  const [isApplyOfferChecked, setIsApplyOfferChecked] = useState(false);
  const { handleLoading } = useContext(LoaderContext);
  const [visible, setVisible] = useState(false);
  const [isMinItemCart, setIsMinItemCart] = useState(false);
  const [editPromocodeData, setEditPromocodeData] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [isRequireUses, setIsRequireUses] = useState(false);
  const [isMinOrderAmount, setIsMinOrderAmount] = useState(false);
  const [isMaxDiscountAmount, setIsMaxDiscountAmount] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: -1,
  });

  const [error, setError] = useState("");
  const getPromoTargetField = (promoFor) => {
    if (promoFor === "Category") return "category";
    if (promoFor === "Sub Category") return "sub_category";
    if (promoFor === "Product") return "product";
    if (promoFor === "Store") return "store";
    return "";
  };

  const normalizeSelectedIds = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (typeof item === "string") return item;
          return item?._id || item?.value || "";
        })
        .filter(Boolean);
    }

    if (typeof value === "string") return [value];
    return value?._id ? [value._id] : [];
  };

  const handleCheckBox = (e, setFieldValue, cb) => {
    const isChecked = e.target.checked;
    console.log("isChecked", isChecked);

    if (isChecked) {
      setFieldValue(e.target.name, e.target.value);
    } else {
      setFieldValue(e.target.name, 0);
    }

    cb(isChecked);
  };

  const handleFileUpload = (e, setFieldValue) => {
    const file = e.target.files[0];
    // console.log("e",e.target.files[0].size/ 1024 / 1024);

    if (file) {
      const fileSizeInMB = file.size / 1024 / 1024;
      if (fileSizeInMB > 1) {
        setError("Please select an image smaller than 1MB.");
        setFieldValue("image", null);
        return;
      }

      setError("");
      setFieldValue("image", file);
    }
  };

  const handleOpen = () => {
    setVisible(true);
    console.log("visible:", visible);
  };
  const handleDeleteClose = () => {
    setDeleteModal(false);
  };

  const handleDelete = async () => {
    handleLoading(true);

    try {
      let res;

      if (editPromocodeData._id) {
        res = await DiscountApi.promocode.deletePromoCode(
          editPromocodeData._id
        );
        toast.success(`${res.data.data}`);
        // beforeMount();
      }

      console.log(res);
    } catch (err) {
      console.log(err);
      // toast.error(`${err.message}`)
    } finally {
      setEditPromocodeData({});
      handleLoading(false);
      handleDeleteClose();
    }
  };

  const handleClose = () => {
    setVisible(false);
  };

  const [optionPromoFor, setOptionPromoFor] = useState([]);
  const normalizePromoOptions = (promoFor, data) => {
    if (Array.isArray(data)) return data;

    if (promoFor === "Store") {
      return data?.users || data?.vendors || data?.stores || [];
    }

    if (promoFor === "Sub Category") {
      return data?.subcategories || [];
    }

    if (promoFor === "Category") {
      return data?.categories || [];
    }

    if (promoFor === "Product") {
      return data?.products || [];
    }

    return [];
  };

  const fetchingPromoforOptions = useCallback(async (promoFor) => {
    handleLoading(true);

    try {
      if (promoFor === "Store") {
        const resStore = await UsersApi.getAllVendor({
          page: 1,
          limit: 200,
          sortOrder: "desc",
          filter: {},
        });
        return resStore.data?.data;
      }

      if (promoFor === "Category") {
        const resCategory =
          currentUser?.delivery_business?.name === "Restourant "
            ? await CategoryApi.getApproveCategory("Food")
            : await CategoryApi.getApproveCategory("Ecommerce");
        // setCategoryData(resCategory.data?.data);
        return resCategory.data?.data;
      }
      if (promoFor === "Sub Category") {
        const resSubCategory =
          currentUser?.delivery_business?.name === "Restourant "
            ? await SubCategoryApi.getAllFoodSubCategory()
            : await SubCategoryApi.getSubCategory();
        // setSubCategoryData(resSubCategory.data?.data)
        return resSubCategory.data?.data;
      }

      if (promoFor === "Product") {
        const resProduct =
          currentUser?.delivery_business?.name === "Restourant "
            ? await productApi.getAllFoodProduct()
            : await productApi.getAllApprovedProduct();
        // setProductData(resProduct.data?.data)
        return resProduct.data?.data;
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      handleLoading(false);
    }
  }, [currentUser?.delivery_business?.name, handleLoading]);
  const handlePromoForOption = async (promoFor) => {
    if (!promoFor) {
      setOptionPromoFor([]);
      return;
    }

    const data = await fetchingPromoforOptions(promoFor);
    const normalizedData = normalizePromoOptions(promoFor, data);
    const option = normalizedData.map((d) => ({
      ...d,
      label: d.name || d.first_name || d.owner_name || "Unnamed",
      value: d._id,
      name: d.name || d.first_name || d.owner_name || "Unnamed",
    }));

    setOptionPromoFor(option || []);
  };

  useEffect(() => {
    if (!visible) {
      setOptionPromoFor([]);
      return;
    }

    const loadPromoTargetOptions = async () => {
      if (!editPromocodeData?.promo_for) return;

      const data = await fetchingPromoforOptions(editPromocodeData.promo_for);
      const normalizedData = normalizePromoOptions(
        editPromocodeData.promo_for,
        data
      );
      const option = normalizedData.map((d) => ({
        ...d,
        label: d.name || d.first_name || d.owner_name || "Unnamed",
        value: d._id,
        name: d.name || d.first_name || d.owner_name || "Unnamed",
      }));

      setOptionPromoFor(option || []);
    };

    loadPromoTargetOptions();
  }, [
    visible,
    editPromocodeData?._id,
    editPromocodeData?.promo_for,
    fetchingPromoforOptions,
  ]);

  const Lable = ({ lable, text_size }) => {
    const { theme } = useSelector((state) => state.theme);
    return (
      <div
        className={`${text_size ? text_size : "text-sm"}  mb-2 ${
          theme === "light"
            ? "bg-secondaryColor text-primaryColor"
            : " text-darkSecondary"
        } `}
      >
        {lable}
      </div>
    );
  };

  const handleSubmit = async (values) => {
    console.log("Offers Value", values);
    handleLoading(true);
    try {
      const res = editPromocodeData._id
        ? await DiscountApi.promocode.updatePromoCode(
            values,
            editPromocodeData._id
          )
        : await DiscountApi.promocode.createPromoCode(values);
      console.log("res", res);
      // beforeMount();
      toast.success(
        editPromocodeData._id ? "Promo Code updated" : "Promo Code Created"
      );
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
    handleClose();
    handleLoading(false);
  };

  const handlePagination = (data) => {
    // console.log(data);

    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };
      // copyfilter[]

      if (data.filter) {
        // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
        // console.log("Object.keys[copyfilter]",Object.keys(data.filter))

        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-4">
        <CommonLayout />

        <button
          onClick={handleOpen}
          className="
    border border-[var(--color--11)]
    px-2 py-2
    rounded-[30px]
    w-35 h-10
    text-[0.9rem] text-[var(--color--2)]
    hover:bg-[var(--color--11)] hover:text-white
    cursor-pointer
    transition
  "
        >
          Add New
        </button>
      </div>

      <PromocodeComp
        pagination={pagination}
        handlePagination={handlePagination}
      />

      {visible && (
        <Formik
          initialValues={{
            image: editPromocodeData?.image || "",
            promo_code: editPromocodeData?.promo_code || null,
            discount_type: editPromocodeData?.discount_type || null,
            discount: editPromocodeData?.discount?.$numberDecimal || 0,
            description: editPromocodeData?.description || null,
            promo_for: editPromocodeData?.promo_for || null,
            category: normalizeSelectedIds(editPromocodeData?.category),
            sub_category: normalizeSelectedIds(editPromocodeData?.sub_category),
            product: normalizeSelectedIds(editPromocodeData?.product),
            store: normalizeSelectedIds(
              editPromocodeData?.store || editPromocodeData?.created_by
            ),
            active: editPromocodeData?.active || false,
            is_validation_date: editPromocodeData?.is_validation_date || false,
            start_date: editPromocodeData?.start_date
              ? moment(editPromocodeData.start_date)
                  .utc()
                  .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
              : null,
            end_date: editPromocodeData?.end_date
              ? moment(editPromocodeData.end_date)
                  .utc()
                  .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
              : null,
            repeat: editPromocodeData?.repeat || null,
            apply_offer_after_orders:
              editPromocodeData?.apply_offer_after_orders || 0,
            required_uses: editPromocodeData?.required_uses || 0,
            min_order_amount:
              Number(editPromocodeData?.min_order_amount?.$numberDecimal) || 0,
            max_discount_amount:
              Number(editPromocodeData?.max_discount_amount?.$numberDecimal) ||
              0,
            min_item_on_cart: editPromocodeData?.min_item_on_cart || 0,
          }}
          onSubmit={handleSubmit}
          // validationSchema={}
        >
          {({ handleChange, setFieldValue, values, handleSubmit }) => (
            <Form>
              <SidebarField
                handleClose={handleClose}
                title={editPromocodeData._id ? "Update Offer" : "Add New Offer"}
                button1={
                  <Button text="Cancel" type="button" onClick={handleClose} />
                }
                button2={
                  <Button text="Submit" type="submit" onClick={handleSubmit} />
                }
              >
                <div className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
                  <div className="relative h-fit w-[95%] shadow-xl rounded-xl m-auto">
                    <label
                      htmlFor="image-upload"
                      className="absolute right-1 top-1 p-2 bg-buttonColor rounded-full cursor-pointer text-secondaryColor"
                    >
                      <TextInput
                        type="file"
                        id="image-upload"
                        accept="image/*"
                        onChange={(e) => handleFileUpload(e, setFieldValue)}
                        // value={values.image}
                        name="image"
                        style={{ display: "none" }}
                      />
                      <MdEdit />
                    </label>
                    {typeof values.image === "object" ? (
                      <ImagePreview file={values.image} Id="promo" />
                    ) : (
                      <img
                        src={values.image ? values.image : promoimg}
                        alt="Promo Not Found"
                      />
                    )}
                  </div>
                  {error && (
                    <p className="text-RedColor text-sm mt-2">{error}</p>
                  )}
                  <div>
                    <div className="flex items-center">
                      <label className="text-sm mb-2 text-gray-700 dark:text-gray-300">
                        Promo code
                      </label>
                      <Tooltip text="give a name to your promo code" />
                    </div>

                    <TextInput
                      name="promo_code"
                      type="text"
                      placeholder="Promo Code"
                      className="w-full border px-3 py-2 rounded-lg mt-1 outline-none focus:ring-2 focus:ring-blue-400"
                      onChange={handleChange}
                      value={values.promo_code}
                    />

                    <ErrorMessage
                      name="promo_code"
                      component="div"
                      className="error"
                    />
                  </div>

                  <div className="flex justify-between gap-2">
                    <div className="w-[90%]">
                      <div className="flex">
                        <Lable lable="Discount type" />
                        <Tooltip text="select descount type" />
                      </div>
                      <select
                        name="discount_type"
                        value={values.discount_type}
                        onChange={(e) =>
                          setFieldValue("discount_type", e.target.value)
                        }
                        style={{
                          padding: "10px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          width: "100%",
                        }}
                      >
                        <option value="" disabled>
                          Select Discount Type
                        </option>
                        <option value="Absolute">Absolute</option>
                        <option value="Percentage">Percentage</option>
                      </select>

                      <ErrorMessage
                        name="discount_type"
                        component="div"
                        className="error"
                      />
                    </div>
                    <div>
                      <label className="text-sm mb-1 block text-gray-700 dark:text-gray-300">
                        Discount
                      </label>

                      <TextInput
                        name="discount"
                        type="number"
                        placeholder="0"
                        className="w-full border px-3 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue-400"
                        onChange={handleChange}
                        value={values.discount}
                      />

                      <ErrorMessage
                        name="discount"
                        component="div"
                        className="error"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex">
                      <Lable lable="Description" />
                      <Tooltip text="give a brief description of your discount" />
                    </div>
                    <TextInput
                      name="description"
                      type="textarea"
                      placeholder=""
                      onChange={handleChange}
                      value={values.description}
                    />
                    <ErrorMessage
                      name="description"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div>
                    <div className="flex">
                      <Lable lable="Promo for" />
                      <Tooltip text="select area of promotion" />
                    </div>
                    <select
                      name="promo_for"
                      value={values.promo_for}
                      onChange={(e) => {
                        const val = e.target.value;

                        setFieldValue("promo_for", val);

                        // Reset dependent values
                        setFieldValue("category", []);
                        setFieldValue("sub_category", []);
                        setFieldValue("product", []);
                        setFieldValue("store", []);

                        handlePromoForOption(val);
                      }}
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        width: "100%",
                      }}
                    >
                      <option value="" disabled>
                        Select Promo For
                      </option>
                      <option value="Store">Store</option>
                      <option value="Category">Category</option>
                      <option value="Sub Category">Sub Category</option>
                      <option value="Product">Product</option>
                    </select>

                    <ErrorMessage
                      name="promo_for"
                      component="div"
                      className="error"
                    />
                  </div>
                  {values.promo_for && (
                    <div className="mb-3">
                      <label className="text-sm block mb-1 font-medium text-gray-700 dark:text-gray-300">
                        {values.promo_for}
                      </label>
                      <MultiSelectDropDown
                        sx={{ width: "100%", minHeight: "42px" }}
                        value={values[getPromoTargetField(values.promo_for)] || []}
                        options={optionPromoFor}
                        optionLabel="name"
                        optionValue="_id"
                        placeholder={`Select ${values.promo_for}`}
                        filter
                        display="chip"
                        maxSelectedLabels={2}
                        disabled={!optionPromoFor.length}
                        handleMultiselectChange={(selectedValues) => {
                          setFieldValue(
                            getPromoTargetField(values.promo_for),
                            selectedValues
                          );
                        }}
                      />

                      <ErrorMessage
                        name={getPromoTargetField(values.promo_for)}
                        component="div"
                        className="error text-red-500 text-sm"
                      />
                    </div>
                  )}
                  {/* Active Offer Toggle */}
                  <div className="flex items-center justify-between py-5 border-b border-gray-200">
                    <div className="flex items-center gap-4">
                      <input
                        type="checkbox"
                        name="active"
                        checked={values.active || false}
                        onChange={handleChange}
                        className="w-5 h-5 text-red-600 rounded border-gray-300 focus:ring-red-500 cursor-pointer transition"
                      />
                      <label className="text-base font-medium text-gray-800 cursor-pointer select-none">
                        Is your offer running?
                      </label>
                    </div>
                    {/* Optional: Show status badge */}
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                        values.active
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {values.active ? "Active" : "Inactive"}
                    </span>
                  </div>

                  {/* Advanced Settings Header */}
                  <div className="mt-8 mb-6">
                    <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                      {/* <span className="w-8 h-8 bg-gray-200 rounded-lg flex items-center justify-center text-gray-600 text-sm">
                        Gear Icon
                      </span> */}
                      Offer Advanced Settings
                    </h3>
                    {/* <p className="text-sm text-gray-500 mt-1">
                      Fine-tune how and when your offer applies
                    </p> */}
                  </div>

                  {/* Validation Date Toggle */}
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200 hover:border-gray-300 transition">
                    <label className="flex items-center justify-between cursor-pointer">
                      <div className="flex items-center gap-4">
                        <input
                          type="checkbox"
                          name="is_validation_date"
                          checked={values.is_validation_date || false}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            if (!checked) {
                              setFieldValue("start_date", null);
                              setFieldValue("end_date", null);
                            }
                            handleChange(e);
                          }}
                          className="w-6 h-6 text-red-600 rounded border-gray-300 focus:ring-red-500 cursor-pointer transition"
                        />
                        <div>
                          <p className="text-base font-medium text-gray-800">
                            Do you want to set offer validation date?
                          </p>
                          <p className="text-sm text-gray-500 mt-1">
                            Limit when this offer can be used
                          </p>
                        </div>
                      </div>
                      {/* Visual indicator */}
                      {/* <div
                        className={`w-12 h-7 flex items-center rounded-full px-1 transition ${
                          values.is_validation_date
                            ? "bg-red-500"
                            : "bg-gray-300"
                        }`}
                      >
                        <div
                          className={`w-5 h-5 bg-white rounded-full shadow-md transform transition ${
                            values.is_validation_date ? "translate-x-5" : ""
                          }`}
                        />
                      </div> */}
                    </label>
                  </div>

                  {/* Optional: Show date range preview when enabled */}
                  {values.is_validation_date && (
                    <div className="mt-4 ml-10 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                      <p className="text-sm text-blue-800 font-medium">
                        Date range will be set in the next step
                      </p>
                    </div>
                  )}

                  {values.is_validation_date && (
                    <div>
                      <div className="flex">
                        <Lable lable="Offer Apply Date Range" />
                        <Tooltip text="set the date range for your offer" />
                      </div>
                      {/* <TextInput
                      name="dateRange"
                      type="text"
                      placeholder="Date Range"
                      onChange={handleChange}
                      value={values.dateRange}
                    /> */}
                      {editPromocodeData._id ? (
                        <Calendar
                          name="dateRange"
                          value={[
                            values.start_date
                              ? new Date(values.start_date)
                              : null,
                            values.end_date ? new Date(values.end_date) : null,
                          ]}
                          onChange={(e) => {
                            if (e.value && Array.isArray(e.value)) {
                              const [start, end] = e.value; // Destructure start and end dates
                              setFieldValue(
                                "start_date",
                                start ? start.toISOString() : null
                              );
                              setFieldValue(
                                "end_date",
                                end ? end.toISOString() : null
                              );
                            }
                          }}
                          selectionMode="range"
                          readOnlyInput
                          hideOnRangeSelection
                          className="border w-full"
                        />
                      ) : (
                        <CalendarComp
                          className="w-full border-[#e5e7eb]"
                          showTime
                          hourFormat="12"
                          sx={{
                            width: "100%",
                            height: "2.5rem",
                          }}
                          value={[
                            values.start_date
                              ? new Date(values.start_date)
                              : null,
                            values.end_date ? new Date(values.end_date) : null,
                          ]}
                          handleFilter={(type, v) => {
                            if (v && v.length === 2) {
                              const formattedDates = v.map((date) =>
                                moment(date)
                                  .utc()
                                  .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
                              );
                              setFieldValue("start_date", formattedDates[0]);
                              setFieldValue("end_date", formattedDates[1]);
                            }
                          }}
                        />
                      )}

                      <ErrorMessage
                        name="dateRange"
                        component="div"
                        className="error"
                      />
                    </div>
                  )}
                  <div>
                    <div className="flex">
                      <Lable lable="Recursion type" />
                      <Tooltip text="select the repertation of offer" />
                    </div>
                    <select
                      name="repeat"
                      value={values.repeat}
                      onChange={(e) => {
                        setFieldValue("repeat", e.target.value);
                      }}
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        width: "100%",
                      }}
                    >
                      <option value="" disabled>
                        Select Recursion Type
                      </option>
                      <option value="No">No Recursion</option>
                      <option value="Daily">Daily Recursion</option>
                      <option value="Weekly">Weekly Recursion</option>
                      <option value="Monthly">Monthly Recursion</option>
                      <option value="Annually">Annually Recursion</option>
                    </select>

                    <ErrorMessage
                      name="repeat"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div>
                    <div className="flex">
                      <Lable lable={"Apply offer after complete no of order"} />
                      <Tooltip text="enter minimum no of order to apply offer" />
                    </div>
                    <div className="flex items-center ">
                      <div className="border px-2.5 py-2">
                        <TextInput
                          type="checkbox"
                          name="apply_offer_after_orders"
                          id="apply_offer_after_orders"
                          value={values.apply_offer_after_orders}
                          checked={
                            Boolean(values.apply_offer_after_orders)
                              ? Boolean(values.apply_offer_after_orders)
                              : isApplyOfferChecked
                          }
                          onChange={(e) =>
                            handleCheckBox(
                              e,
                              setFieldValue,
                              setIsApplyOfferChecked
                            )
                          }
                        />
                      </div>
                      <TextInput
                        name="apply_offer_after_orders"
                        type="number"
                        placeholder="0"
                        onChange={handleChange}
                        value={values.apply_offer_after_orders}
                        disabled={!isApplyOfferChecked}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex">
                      <Lable lable={"Required Uses"} />
                      <Tooltip text="enter the number of required uses" />
                    </div>
                    <div className="flex items-center ">
                      <div className="border px-2.5 py-2">
                        <TextInput
                          type="checkbox"
                          name="required_uses"
                          id="required_uses"
                          value={values.required_uses}
                          checked={
                            Boolean(values.required_uses)
                              ? Boolean(values.required_uses)
                              : isRequireUses
                          }
                          onChange={(e) =>
                            handleCheckBox(e, setFieldValue, setIsRequireUses)
                          }
                        />
                      </div>
                      <TextInput
                        name="required_uses"
                        type="number"
                        placeholder="0"
                        onChange={handleChange}
                        value={values.required_uses}
                        disabled={!isRequireUses}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex">
                      <Lable
                        lable={
                          "Do you want to set min order amount for apply ?"
                        }
                      />
                      <Tooltip text="you can set minimum order amount to apply offer" />
                    </div>
                    <div className="flex items-center ">
                      <div className="border px-2.5 py-2">
                        <TextInput
                          type="checkbox"
                          name="min_order_amount"
                          id="min_order_amount"
                          value={values.min_order_amount}
                          checked={
                            Boolean(values.min_order_amount)
                              ? Boolean(values.min_order_amount)
                              : isMinOrderAmount
                          }
                          onChange={(e) =>
                            handleCheckBox(
                              e,
                              setFieldValue,
                              setIsMinOrderAmount
                            )
                          }
                        />
                      </div>
                      <TextInput
                        name="min_order_amount"
                        type="number"
                        placeholder="0"
                        onChange={handleChange}
                        value={values.min_order_amount}
                        disabled={!isMinOrderAmount}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex">
                      <Lable
                        lable={"Do you want to set max discount amount ?"}
                      />
                      <Tooltip text="you can set maximum discounted amount here" />
                    </div>
                    <div className="flex items-center ">
                      <div className="border px-2.5 py-2">
                        <TextInput
                          type="checkbox"
                          name="max_discount_amount"
                          id="max_discount_amount"
                          // checked={isMaxDiscountAmount}
                          // onChange={(e) =>
                          //   setIsMaxDiscountAmount(e.target.checked)
                          // }
                          value={values.max_discount_amount}
                          checked={
                            Boolean(values.max_discount_amount)
                              ? Boolean(values.max_discount_amount)
                              : isMaxDiscountAmount
                          }
                          onChange={(e) =>
                            handleCheckBox(
                              e,
                              setFieldValue,
                              setIsMaxDiscountAmount
                            )
                          }
                        />
                      </div>
                      <TextInput
                        name="max_discount_amount"
                        type="number"
                        placeholder="0"
                        onChange={handleChange}
                        value={values.max_discount_amount}
                        disabled={!isMaxDiscountAmount}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex">
                      <Lable
                        lable={
                          "Do you want to set min item on cart for apply ?"
                        }
                      />
                      <Tooltip text="you can set minimum number of item on cart to apply offer" />
                    </div>
                    <div className="flex items-center ">
                      <div className="border px-2.5 py-2">
                        <TextInput
                          type="checkbox"
                          name="min_item_on_cart"
                          id="min_item_on_cart"
                          value={values.min_item_on_cart}
                          checked={
                            Boolean(values.min_item_on_cart)
                              ? Boolean(values.min_item_on_cart)
                              : isMinItemCart
                          }
                          onChange={(e) =>
                            handleCheckBox(e, setFieldValue, setIsMinItemCart)
                          }
                        />
                      </div>
                      <TextInput
                        name="min_item_on_cart"
                        type="number"
                        placeholder="0"
                        onChange={handleChange}
                        value={values.min_item_on_cart}
                        disabled={!isMinItemCart}
                      />
                    </div>
                  </div>
                </div>
              </SidebarField>
            </Form>
          )}
        </Formik>
      )}
      <DeleteFieldModal
        isOpen={deleteModal}
        onClose={handleDeleteClose}
        onDelete={() => handleDelete()}
      />
    </div>
  );
};

export default Promocode;

// {
//   "title": "Current Week",
//   "path": "history/current-week",
//   "icon": "SlCalender"
// },
// {
//   "title": "Current Month",
//   "path": "history/current-month",
//   "icon": "VscCalendar"
// },

/*
"submenu": [
      {
        "icon": "IoMdCart",
        "title": "Create Order",
        "path": "order/create-order"
      }
    ],
 */
